import React, { useState } from 'react';
// eslint-disable-next-line
import { useAsObservableSource } from 'mobx-react-lite';
import { observer } from 'src/utils/mobx-react';
import { TabsItemState } from 'src/domains/sportsbook/webview/components/raceCard/tabs/TabsItem.state';
import { FilterItem } from 'src/domains/sportsbook/webview/components/raceCard/tabs/TabsItem.style';
import { TabItemType } from 'src/domains/sportsbook/webview/components/raceCard/tabs/Tabs.type';
import { FiltersSkinType } from 'src/domains/layouts/webview/components/filters/FiltersSkin';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

export interface TabsItemPropsType {
    item: TabItemType;
    skin?: FiltersSkinType;
}

export const TabsItem = observer('TabsItem', (propsIn: TabsItemPropsType): JSX.Element => {
    const props = useAsObservableSource(propsIn);
    const [state] = useState(() => new TabsItemState(props));
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;

    const { item } = props;
    const isActive = item.isActive();
    const isFinished = item.isFinished;

    return (
        <FilterItem
            key={item.key}
            onClick={state.setActive}
            isActive={isActive}
            data-is-active={isActive}
            isFinished={isFinished}
            data-test-filter-item-key={item.key}
            skin={props.skin}
            variant={configState.componentVariants.sportsbookVariant}
        >
            {item.label}
        </FilterItem>
    );
});
